import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchPlans, updatePlan } from "../api/plansApi";
import type { UpdatePlanData } from "../types";

const QUERY_KEY = ["plans"];

export const usePlansQuery = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchPlans,
  });
};

export const useUpdatePlanMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdatePlanData }) =>
      updatePlan(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
